<div class="modal-header">
  <h4 class="modal-title">Document Viewer</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <iframe [src]="pdfUrl"></iframe>
  <p>
    Having trouble viewing this document?
    <a [routerLink]="" (click)="viewDocument()" class="text-nowrap">
      View Document.
    </a>
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="download()">Download</button>
  <button type="button" class="btn btn-primary" (click)="close()">Close</button>
</div>
